
import { Component, Vue } from "vue-property-decorator";
//import ProblemVue from "./Problem.vue";
import FinderVue from "@/finder/Finder.vue";

import { IProblem, Dict } from "@/problem/IProblem";

import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import  ButtonVue from "@/lib/Button.vue";
import UploaderVue from "@/uploader/Uploader.vue";
import { IProblemSvc, problem_api } from "@/problem/IProblemSvc";
import { ProblemSvc } from "@/problem/ProblemSvc";
import { Next, Route } from 'vue-router';
import { IUser } from "@/../../server/src/user/IUser";

@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<ProblemVue>) {
            console.log("********************* beforeRouteEnter:", to.path, to.params.problem_id )
            next((vm: ProblemVue) => { vm.id = to.params.problem_id  });
        },
        components: { ButtonVue, FinderVue} 
        })

export default class ProblemVue extends Vue {

  id:string="";
  _id:string="";
  problem: IProblem|undefined=undefined;
  key=0;
  new_labels=0;
  problemSvc=new ProblemSvc()
  dict=new Dict()
  
  async chg() {
    if (!this.problem) return;
    console.log("problem:chg")
    const problem =  await this.problemSvc.update(this.problem)
    if (problem && problem.version) {
      this.problem.version = problem.version;
    }
    this.key++;
  }

  async ch_status(status:string) {
    if (!this.problem) return;
    if (!confirm("Czy zmienić status problemu na "+status+"?")) return;
    
    this.problem.status=status;

    if (status=="4. ZAMKNIĘTY") {
      this.problem.data_zamkniecia=new Date()
      const user:IUser=JSON.parse(bus.get_token()).user
      this.problem.zakonczyl=user.data_username
    }
    else if (status=="2. PRACA ROZPOCZĘTA") {
      if (!this.problem.data_rozpoczecia_pracy) {
        this.problem.data_rozpoczecia_pracy=new Date()
      }
    }
    else if (status=="3. PRACA ZAKOŃCZONA") {
      if (this.problem.data_rozpoczecia_pracy) {
        this.problem.data_zakonczenia_pracy=new Date()
      }
    }

    await this.chg();
  }

async refresh() {

      console.log("refresh using id", this.id);
      const l = await this.problemSvc.find_by_id( this.id );
      if (l) {
        this.problem = l;
        this.key++;
      }
}


 async del_problem(l: IProblem) {
    if (confirm("Na pewno skasować urządzenie "+l.idn+"?")) {
      const problem = await this.problemSvc.delete(l);
    }
  }


  async mounted() {
    console.log('problem mounted', this.id)
    await this.refresh();
  }

}
